import React, { useState } from 'react';
import {
    createStyles,
    ActionIcon,
    Stack,
    Title,
    Group,
    Progress,
    Card,
    Flex,
    Modal,
    RingProgress,
    Text,
    ScrollArea,
    Divider
} from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import {
    IconGavel,
    IconArticle,
    IconPhotoEdit,
    IconDeviceFloppy,
    IconArrowBigRight,
    IconX,
    IconChevronsDown,
    IconEdit,
    IconPencil,
    IconListDetails,
    IconEye
} from '@tabler/icons';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import { 
    testGalleryUpdated,
    selectAllTestData,
    selectIntroGallery,
    carCreatorSelectSectionDataB
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';

//below is the line where we import items from different slices
//import {}
import { CarCreationCardA } from '../components/CarCreationCardA';
import { CarCreationCardB } from '../components/CarCreationCardB';
import { CarCreationCardC } from '../components/CarCreationCardC';
import { CarComponent } from '../components/CarComponent';
import { CarCardDets } from '../components/CarCardDets';
import CarCardDetsHighlightsMgmt from '../components/CarCardDetsHighlightsMgmt';
import {DragNDropEx} from '../components/DragNDropEx';


//needed: car preview and dets


//default assets
import crypto_symbols from '../assets/crypto_symbols.jpg';
import koenigsegg from '../assets/koenigsegg.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    cardStyle: {
        width: '85%',
        maxWidth: '800px'
    },
    leftCardSection: {
        marginLeft: '0%'
    },
    
}));

const names = [
    {
        id: nanoid(),
        name: 'List Title 0',
        position: 0
    },
    {
        id: nanoid(),
        name: 'List Title 1',
        position: 1
    },
    {
        id: nanoid(),
        name: 'List Title 2',
        position: 2
    },
    {
        id: nanoid(),
        name: 'List Title 3',
        position: 3
    },
];


//needed:ability to opt-out of sections article
//needed:copy to a 'components' page for erik to see
export function CarCreationContain (){
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const { height, width } = useViewportSize();

    //of_note:need useSelectors and dispatch events to update the flow in real
    //keeping track of form completion
    //also necessary we need to repopulate the fields after the section has been closed(if not the first time for this listing)
    const [detsOpened, setDetsOpened] = useState(false);
    const [sectionAPercComp, setSectionAPercComp] = useState(0);
    const [stepBOpened, setStepBOpened] = useState(false);
    const [sectionBPercComp, setSectionBPercComp] = useState(0);
    const [stepCOpened, setStepCOpened] = useState(false);
    const [sectionCPercComp, setSectionCPercComp] = useState(0);
    const [stepDOpened, setStepDOpened] = useState(false);
    const [sectionDPercComp, setSectionDPercComp] = useState(0);


    //descript:old but kept for reference 
    const testImages = useSelector(selectIntroGallery);
    let authHold = {
        src: koenigsegg,
        name: "John Does"
    }
    function handleClick(e){
        console.log('hit the click');
        console.log(window.history);
        window.history.forward()
    }
    
    
    return(
        <>
            <ScrollArea
                h={height * 0.85}
                type="never"
            >
                <Group position="apart" spacing="xl">
                    <Stack
                        align="center"
                        justify="center"
                    >
                        <ActionIcon
                            name="cancel"
                            radius="lg"
                            size="xl"
                            color="red"
                        >
                            <IconX id="cancelListing" size={32} stroke={2.5}/>
                        </ActionIcon>
                        <Text ta="center">
                            Cancel
                        </Text>
                    </Stack>
                    <Stack
                        align="center"
                        justify="center"
                    >
                        <ActionIcon
                            name="preview"
                            radius="lg"
                            size="xl"
                            color="green"
                        >
                            <IconEye id="nextStep" size={32} stroke={2.5}/>
                        </ActionIcon>
                        <Text ta="center">
                            Preview
                        </Text>
                    </Stack>
                    <Stack
                        align="center"
                        justify="center"
                    >
                        <ActionIcon
                            name="save_draft"
                            radius="lg"
                            size="xl"
                            color="dark"
                        >
                            <IconDeviceFloppy id="saveDraft" size={32} stroke={2.1}/>
                        </ActionIcon>
                        <Text ta="center">
                            Save
                        </Text>
                    </Stack>
                </Group>
                <Divider/>
                <br/>
                <br/>
                
                <Stack
                    align="center"
                    justify="space-around"
                >
                    <Card
                        className={classes.cardStyle/**/}
                        shadow="sm"
                        p="lg"
                        radius="md"
                        withBorder
                    >
                        <Card.Section>
                            <Group position="center" spacing="xl">
                                <Stack
                                    className={classes.marginLeft}
                                    align="center"
                                    justify="center"
                                    name="details_contain"
                                    onClick={() => setDetsOpened(true)}
                                >
                                    <ActionIcon
                                        radius="lg"
                                        size="xl"
                                        variant="transparent"
                                        color="dark"
                                    >
                                        <IconGavel size={36} stroke={2.0}/>
                                    </ActionIcon>
                                    <Text td="underline" fz="xl">
                                        Details
                                    </Text>
                                </Stack>
                                <RingProgress label={
                                    <Text size="md" align="center">
                                        0%
                                    </Text>
                                }
                                sections={[
                                    { value: 100, color: 'grey' },
                                ]}
        
                                />
                            </Group>
                        </Card.Section>
                    </Card>
    
                    
                    <Card
                        className={classes.cardStyle}
                        shadow="sm"
                        p="lg"
                        radius="md"
                        withBorder
                    >
                        <Card.Section>
                            <Group position="center" spacing="xl">
                                <Stack
                                    className={classes.marginLeft}
                                    align="center"
                                    justify="center"
                                    name="article_contain"
                                    onClick={() => setStepBOpened(true)}
                                >
                                    <ActionIcon
                                        radius="lg"
                                        size="xl"
                                        variant="transparent"
                                        color="dark"
                                    >
                                        <IconArticle size={36} stroke={2.0}/>
                                    </ActionIcon>
                                    <Text td="underline" fz="xl">
                                        Article
                                    </Text>
                                </Stack>
                                <RingProgress label={
                                    <Text size="md" align="center">
                                        0%
                                    </Text>
                                }
                                sections={[
                                    { value: 100, color: 'grey' },
                                ]}
        
                                />
                            </Group>
                        </Card.Section>
                    </Card>
    
    
                    <Card
                        className={classes.cardStyle}
                        shadow="sm"
                        p="lg"
                        radius="md"
                        withBorder
                    >
                        <Card.Section>
                            <Group position="center" spacing="xl">
                                <Stack
                                    className={classes.marginLeft}
                                    align="center"
                                    justify="center"
                                    name="article_contain"
                                    onClick={() => setStepDOpened(true)}
                                >
                                    <ActionIcon
                                        radius="lg"
                                        size="xl"
                                        variant="transparent"
                                        color="dark"
                                    >
                                        <IconListDetails size={36} stroke={2.0}/>
                                    </ActionIcon>
                                    <Text td="underline" fz="xl">
                                        Lists
                                    </Text>
                                </Stack>
                                <RingProgress label={
                                    <Text size="md" align="center">
                                        0%
                                    </Text>
                                }
                                sections={[
                                    { value: 100, color: 'grey' },
                                ]}
        
                                />
                            </Group>
                        </Card.Section>
                    </Card>
    
                    <Card
                        className={classes.cardStyle}
                        shadow="sm"
                        p="lg"
                        radius="md"
                        withBorder
                    >
                        <Card.Section>
                            <Group position="center" spacing="xl">
                                <Stack
                                    className={classes.marginLeft}
                                    align="center"
                                    justify="center"
                                    name="media_contain"
                                    onClick={() => setStepCOpened(true)}
                                >
                                    <ActionIcon
                                        radius="lg"
                                        size="xl"
                                        variant="transparent"
                                        color="dark"
                                    >
                                        <IconPhotoEdit size={36} stroke={2.0}/>
                                    </ActionIcon>
                                    <Text td="underline" fz="xl">
                                        Media
                                    </Text>
                                </Stack>
                                <RingProgress label={
                                    <Text size="md" align="center">
                                        0%
                                    </Text>
                                }
                                sections={[
                                    { value: 0, color: 'green' },
                                    { value: 100, color: 'grey' },
                                ]}
        
                                />
                            </Group>
                        </Card.Section>
                    </Card>
                    
                </Stack>
                <br/>
            </ScrollArea>
            <br/>
            <br/>
            
            
            
            <Modal
                fullScreen={true}
                opened={detsOpened}
                returnFocus={true}
                onClose={() => setDetsOpened(false)}
                overflow="inside"
            >
                <CarCreationCardA/>
                {/*<DragNDropEx vals={names}/>*/}
                
            </Modal>
            
            <Modal
                overflow="inside"
                fullScreen={true}
                returnFocus={true}
                opened={stepBOpened}
                onClose={() => setStepBOpened(false)}
            >
                <CarCreationCardB />
            </Modal>
            <Modal
                returnFocus={true}
                fullScreen={true}
                opened={stepCOpened}
                onClose={() => setStepCOpened(false)}
            >
                <CarCreationCardC />
            </Modal>
            <Modal
                returnFocus={true}
                opened={stepDOpened}
                title={"Highlights Management"}
                fullScreen={true}
                onClose={() => setStepDOpened(false)}
            >
                <CarCardDetsHighlightsMgmt />
            </Modal>
        </>
    )
}
